import { useTranslation } from "react-i18next";

import {
  Image,
  Button
} from '@lockerpm/design';

import global from '../../config/global';

function AllBrowsers(props) {
  const {
    className = ''
  } = props;

  const { t } = useTranslation();
  const allBrowsers = global.constants.BROWSERS

  return (
    <div className={`${className}`}>
      <div className="flex flex-wrap justify-center gap-x-3 mb-4">
        {
          allBrowsers.map((b) => <div
            key={b.name}
            className="w-[135px] mt-6 text-webkit text-center"
          >
            <div className="h-[60px] flex justify-center">
              <Image
                src={b.imgSrc}
                preview={false}
              />
            </div>
            <p className="mt-3 font-semibold">{b.name}</p>
            {
              b.active && <a href={b.link} target="_blank">
                <Button
                  className="mt-3"
                  type="primary"
                >
                  {t('common.install')}
                </Button>
              </a>
            }
            {
              !b.active && <Button
                className="mt-3"
                disabled
              >
                {t('common.coming')}
              </Button>
            }
          </div>)
        }
      </div>
    </div>
  );
}

export default AllBrowsers;
